export default __webpack_public_path__ + "static/media/ameyo1.d918eca7.jpeg";